// extracted by mini-css-extract-plugin
export default {"wrapper":"TemperatureContainer_wrapper__aVv+i","arrow":"TemperatureContainer_arrow__h52H7"};